
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import { resourceCode } from "@/config/global.strings";
import { TermState } from "@/models/www/store/BookingState";
import { useBookingStore } from "@/store/booking";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent, reactive } from "vue";
import useExtras from "@/composables/useExtras";
import { TermTypeEnum } from "@/models/enums";

export default defineComponent({
  	components: {
    	BaseCheckbox,
  	},
	props: {
		componentIndex: {
			type: Number,
			required: false,
		},
		innerContent: String,
		identifier: String,
		code: String,
		label: String,
		disabled: Boolean
	},
  	setup(props) {
	  	const bookingStore = useBookingStore();
		const { setExtraComponentChecked } = useExtras();

        const inputValue = computed({
					get(): boolean {
					
						const checked = bookingStore.getTerm(props.identifier)?.checked ?? false;
						
						//if term is checked, close the section where the checkbox exist
						if (props.componentIndex) {
					    	setExtraComponentChecked(props.componentIndex, checked);
				    	}	

	        			return checked;
					},
				set(value: boolean) {
					bookingStore.setTerm({ identifier: props.identifier, checked: value } as TermState);

					if (props.componentIndex) {
						setExtraComponentChecked(props.componentIndex, value);
					}
				},
		});


		const rules = {
			checked: {
				v: helpers.withMessage(
					() => props.identifier === TermTypeEnum[TermTypeEnum.ExcessLuggage] ? 'You need to confirm that you are not bringing any excess luggage on your travel or pre-book what items you are bringing' : 'Required',
					() => { return inputValue.value }
				)
			},
		};

		const v$ = useVuelidate(rules, reactive({ checked: inputValue.value }));

		return { inputValue, resourceCode, v$ };
  	}
});
